import {
  Box, Button,
  FormControlLabel,
  Grid,
  InputLabel,
  Typography,
} from "@mui/material";
import React, { memo, useState } from "react";
import VpnKeyIcon from "@mui/icons-material/VpnKey";
import { Data } from "../../../../store/terminal/types";
import { saveRequest as ResetTerminalStan } from "../../../../store/resetSTAN/actions";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
interface RestTerminalSTANProps {
  terminal: Data | undefined;
  afterResetSuccess?: Function;
  isResetSTANAllowed?: boolean;
}

const EditTerminalResetSTAN = ({ terminal, afterResetSuccess,isResetSTANAllowed }: RestTerminalSTANProps) => {
  const dispatch = useDispatch();
  const [stan, setStan] = useState(terminal.attributes.STAN as string);
  const resetTerminalSTAN = (terminal_id: string) => {
    const resetTerminalSTANData = {
      terminal_id,
    };

    dispatch(ResetTerminalStan(resetTerminalSTANData, (err) => {
      if (err) {
        let errText = "";
        errText += `Reset failed! An error occurred while resetting terminal STAN.`;
        toast.error(errText, {
          closeOnClick: true,
        });
      } else {
        toast.success("Reset succeeded! Terminal STAN has been successfully reset.", {
          closeOnClick: true,
        });
        setStan('000000');
      }
    }));
  };

  return (
    <div>
      <Typography>{stan}
      </Typography>
      {isResetSTANAllowed && <Button
        variant="outlined"
        color="primary"
        size="small"
        onClick={() => resetTerminalSTAN(terminal.id)}
      >
        Reset STAN
      </Button>}

    </div>

  );
};

export default memo(EditTerminalResetSTAN);
